import gql from 'graphql-tag';
import AuthenticationResultFragment from '../fragments/AuthenticationResultFragment';

export default gql`
mutation adminLogin ($email: String!, $password: String!, $type: AuthenticationType!) {
    adminLogin (credentials: {email: $email, password: $password, authType: $type}) {
        ...AuthenticationResultFragment
    }
}
${AuthenticationResultFragment}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/mutations/adminLogin.ts